import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      // Navigation
      nav: {
        home: "Home",
        projects: "Projects",
        experience: "Experience",
        education: "Education",
        contact: "Contact"
      },
      // Main Section
      main: {
        hi: "Hi,",
        im: "I'm",
        description: "Passionate Web Developer with expertise in modern JavaScript technologies. Currently at Salvia, I design high-performance web applications using Next.js and NestJS. Graduate of YouCode (UM6P) and pursuing a degree in Computer Science Development at Faculté Aïn Chock. My journey combines solid practical experience with Laravel, PHP, and microservices architectures, as well as mastery of Agile methodologies and DevOps practices.",
        viewResume: "View Resume"
      },
      // Experience Section
      experience: {
        title: "Experience",
        education: "Education",
        skills: "Technical Skills",
        skillsDesc: "Full-stack technical expertise with modern web development, microservices architecture, and cloud deployment."
      },
      // Skills
      skills: {
        languages: "Languages",
        frontend: "Frontend & UI",
        backend: "Backend & APIs",
        database: "Databases",
        devops: "DevOps & Cloud",
        testing: "Testing & Quality",
        tools: "Tools & Methodologies"
      },
      // Experience Data
      experienceData: {
        salvia: {
          title: "Web/Mobile Developer – Salvia, Safi",
          date: "11/2025 – Present",
          description: "Development of modern web applications using a complete JavaScript stack. Creation of high-performance and responsive user interfaces with Next.js, leveraging server-side rendering (SSR) and static generation (SSG) to optimize performance and SEO. Development of robust and scalable APIs with NestJS, implementing modular architecture, dependency injection, and TypeScript best practices. Team collaboration to deliver high-quality technical solutions meeting business needs."
        },
        hedoma: {
          title: "Full Stack Developer – Hedoma-Group, Kenitra",
          date: "03/2025 – 10/2025",
          description: "Development and maintenance of the ministerial dashboard Enquete-industrielle.ma in an Agile environment. Design and implementation of RESTful APIs with Laravel, including MVC architecture, database migration management, and MySQL query optimization. Creation of responsive user interfaces with JavaScript and Blade, ensuring a smooth and intuitive experience. Implementation of unit tests, code review via GitHub, and close collaboration with stakeholders to ensure technical and functional alignment of deliverables."
        },
        eysi: {
          title: "Full Stack Developer – Internship, Eysi, Marrakesh",
          date: "06/2024 – 07/2024",
          description: "Design and development of a complete inventory management platform with modern architecture. Backend development in PHP for business logic and APIs, coupled with a Next.js frontend for optimal performance and SEO. Implementation of a MySQL database with normalized schemas and complex relationships. Project management with Jira using Agile methodology, versioning via GitHub, and implementation of CI/CD pipelines to automate deployments and ensure code quality."
        }
      },
      // Education Data
      educationData: {
        ainChock: {
          title: "Faculté Aïn Chock – Casablanca",
          date: "Ongoing",
          description: "Computer Science Development"
        },
        youcode: {
          title: "Youcode ( UM6P ) – Safi",
          date: "2023 - 2025",
          description: "Full-Stack Web Development"
        },
        istia: {
          title: "ISTIA Al Massira – El Jadida",
          date: "2018 - 2020",
          description: "Specialized Technician in Electronics"
        },
        safi: {
          title: "Faculté Polydisciplinaire de Safi",
          date: "2016 - 2018",
          description: "Physical Matter Sciences"
        },
        lycee: {
          title: "Lycée IBN Khaldoun – Safi",
          date: "2015 - 2016",
          description: "Baccalaureate in Physical Sciences"
        }
      },
      // Contact
      contact: {
        title: "Get In Touch",
        description: "Feel free to reach out for collaboration or just a friendly hello"
      }
    }
  },
  fr: {
    translation: {
      // Navigation
      nav: {
        home: "Accueil",
        projects: "Projets",
        experience: "Expérience",
        education: "Formation",
        contact: "Contact"
      },
      // Main Section
      main: {
        hi: "Salut,",
        im: "Je suis",
        description: "Développeur Web passionné avec une expertise en technologies JavaScript modernes. Actuellement chez Salvia, je conçois des applications web performantes avec Next.js et NestJS. Diplômé de YouCode (UM6P) et poursuivant un cursus en Développement Informatique à la Faculté Aïn Chock. Mon parcours combine une solide expérience pratique avec Laravel, PHP, et des architectures microservices, ainsi qu'une maîtrise des méthodologies Agile et des pratiques DevOps.",
        viewResume: "Voir CV"
      },
      // Experience Section
      experience: {
        title: "Expérience",
        education: "Formation",
        skills: "Compétences Techniques",
        skillsDesc: "Stack technique full-stack avec expertise en développement web moderne, architecture microservices et déploiement cloud."
      },
      // Skills
      skills: {
        languages: "Langages",
        frontend: "Frontend & UI",
        backend: "Backend & APIs",
        database: "Bases de Données",
        devops: "DevOps & Cloud",
        testing: "Tests & Qualité",
        tools: "Outils & Méthodologies"
      },
      // Experience Data
      experienceData: {
        salvia: {
          title: "Développeur Web/Mobile – Salvia, Safi",
          date: "11/2025 – En cours",
          description: "Développement d'applications web modernes utilisant une stack JavaScript complète. Création d'interfaces utilisateur performantes et réactives avec Next.js, exploitant le rendu côté serveur (SSR) et la génération statique (SSG) pour optimiser les performances et le référencement. Développement d'APIs robustes et scalables avec NestJS, implémentant une architecture modulaire, l'injection de dépendances et les bonnes pratiques TypeScript. Collaboration en équipe pour livrer des solutions techniques de haute qualité répondant aux besoins métier."
        },
        hedoma: {
          title: "Développeur Full Stack – Hedoma-Group, Kenitra",
          date: "03/2025 – 10/2025",
          description: "Développement et maintenance du tableau de bord ministériel Enquete-industrielle.ma dans un environnement Agile. Conception et implémentation d'APIs RESTful avec Laravel, incluant l'architecture MVC, la gestion des migrations de base de données et l'optimisation des requêtes MySQL. Création d'interfaces utilisateur réactives avec JavaScript et Blade, garantissant une expérience fluide et intuitive. Mise en place de tests unitaires, revue de code via GitHub, et collaboration étroite avec les parties prenantes pour assurer l'alignement technique et fonctionnel des livrables."
        },
        eysi: {
          title: "Développeur Full Stack – Stage, Eysi, Marrakesh",
          date: "06/2024 – 07/2024",
          description: "Conception et développement d'une plateforme complète de gestion de stock avec architecture moderne. Développement backend en PHP pour la logique métier et les APIs, couplé à une interface frontend en Next.js pour des performances optimales et SEO. Implémentation d'une base de données MySQL avec schémas normalisés et relations complexes. Gestion de projet avec Jira en méthodologie Agile, versioning via GitHub, et mise en place de pipelines CI/CD pour automatiser les déploiements et garantir la qualité du code."
        }
      },
      // Education Data
      educationData: {
        ainChock: {
          title: "Faculté Aïn Chock – Casablanca",
          date: "En cours",
          description: "Développement Informatique"
        },
        youcode: {
          title: "Youcode ( UM6P ) – Safi",
          date: "2023 - 2025",
          description: "Développement Web Full-Stack"
        },
        istia: {
          title: "ISTIA Al Massira – El Jadida",
          date: "2018 - 2020",
          description: "Technicien Spécialisé en Électronique"
        },
        safi: {
          title: "Faculté Polydisciplinaire de Safi",
          date: "2016 - 2018",
          description: "Sciences de la Matière Physique"
        },
        lycee: {
          title: "Lycée IBN Khaldoun – Safi",
          date: "2015 - 2016",
          description: "Baccalauréat en Sciences Physiques"
        }
      },
      // Contact
      contact: {
        title: "Contactez-moi",
        description: "N'hésitez pas à me contacter pour une collaboration ou simplement pour discuter"
      }
    }
  },
  de: {
    translation: {
      // Navigation
      nav: {
        home: "Startseite",
        projects: "Projekte",
        experience: "Erfahrung",
        education: "Bildung",
        contact: "Kontakt"
      },
      // Main Section
      main: {
        hi: "Hallo,",
        im: "Ich bin",
        description: "Leidenschaftlicher Web-Entwickler mit Expertise in modernen JavaScript-Technologien. Derzeit bei Salvia entwickle ich leistungsstarke Webanwendungen mit Next.js und NestJS. Absolvent von YouCode (UM6P) und studiere Informatik-Entwicklung an der Faculté Aïn Chock. Meine Reise vereint solide praktische Erfahrung mit Laravel, PHP und Mikroservice-Architekturen sowie die Beherrschung agiler Methoden und DevOps-Praktiken.",
        viewResume: "Lebenslauf ansehen"
      },
      // Experience Section
      experience: {
        title: "Erfahrung",
        education: "Bildung",
        skills: "Technische Fähigkeiten",
        skillsDesc: "Full-Stack-Expertise mit moderner Webentwicklung, Mikroservice-Architektur und Cloud-Deployment."
      },
      // Skills
      skills: {
        languages: "Sprachen",
        frontend: "Frontend & UI",
        backend: "Backend & APIs",
        database: "Datenbanken",
        devops: "DevOps & Cloud",
        testing: "Testing & Qualität",
        tools: "Tools & Methoden"
      },
      // Experience Data
      experienceData: {
        salvia: {
          title: "Web-/Mobile-Entwickler – Salvia, Safi",
          date: "11/2025 – Gegenwart",
          description: "Entwicklung moderner Webanwendungen mit einem vollständigen JavaScript-Stack. Erstellung leistungsstarker und responsiver Benutzeroberflächen mit Next.js unter Nutzung von Server-Side Rendering (SSR) und statischer Generierung (SSG) zur Optimierung von Leistung und SEO. Entwicklung robuster und skalierbarer APIs mit NestJS unter Implementierung modularer Architektur, Dependency Injection und TypeScript Best Practices. Teamzusammenarbeit zur Bereitstellung hochwertiger technischer Lösungen, die Geschäftsanforderungen erfüllen."
        },
        hedoma: {
          title: "Full-Stack-Entwickler – Hedoma-Group, Kenitra",
          date: "03/2025 – 10/2025",
          description: "Entwicklung und Wartung des ministeriellen Dashboards Enquete-industrielle.ma in einer agilen Umgebung. Design und Implementierung von RESTful APIs mit Laravel, einschließlich MVC-Architektur, Datenbankmigrationsverwaltung und MySQL-Abfrageoptimierung. Erstellung responsiver Benutzeroberflächen mit JavaScript und Blade für ein reibungsloses und intuitives Erlebnis. Implementierung von Unit-Tests, Code-Review über GitHub und enge Zusammenarbeit mit Stakeholdern zur Sicherstellung der technischen und funktionalen Ausrichtung der Ergebnisse."
        },
        eysi: {
          title: "Full-Stack-Entwickler – Praktikum, Eysi, Marrakesh",
          date: "06/2024 – 07/2024",
          description: "Design und Entwicklung einer kompletten Bestandsverwaltungsplattform mit moderner Architektur. Backend-Entwicklung in PHP für Geschäftslogik und APIs, gekoppelt mit einem Next.js-Frontend für optimale Leistung und SEO. Implementierung einer MySQL-Datenbank mit normalisierten Schemas und komplexen Beziehungen. Projektmanagement mit Jira unter Verwendung agiler Methodik, Versionierung über GitHub und Implementierung von CI/CD-Pipelines zur Automatisierung von Bereitstellungen und Sicherstellung der Codequalität."
        }
      },
      // Education Data
      educationData: {
        ainChock: {
          title: "Faculté Aïn Chock – Casablanca",
          date: "Laufend",
          description: "Informatik-Entwicklung"
        },
        youcode: {
          title: "Youcode ( UM6P ) – Safi",
          date: "2023 - 2025",
          description: "Full-Stack-Webentwicklung"
        },
        istia: {
          title: "ISTIA Al Massira – El Jadida",
          date: "2018 - 2020",
          description: "Spezialisierter Techniker für Elektronik"
        },
        safi: {
          title: "Faculté Polydisciplinaire de Safi",
          date: "2016 - 2018",
          description: "Physikalische Materialwissenschaften"
        },
        lycee: {
          title: "Lycée IBN Khaldoun – Safi",
          date: "2015 - 2016",
          description: "Abitur in Physikalischen Wissenschaften"
        }
      },
      // Contact
      contact: {
        title: "Kontaktieren Sie mich",
        description: "Kontaktieren Sie mich gerne für eine Zusammenarbeit oder einfach für ein freundliches Hallo"
      }
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
